import React from "react"
import autobind from "class-autobind"
import { Paper, Avatar } from "material-ui"
import AvatarPlaceholder from "material-ui/svg-icons/action/perm-identity"
import ShieldIcon from "material-ui/svg-icons/action/verified-user"
import { INoteDocument } from "../../models"
import * as permissionHelper from "../.././helpers/permissionHelper"
import TableFooter from "../layout/TableFooter"
import moment from "moment"
import strings from "../../localization/strings"

interface IProps {
    notes: INoteDocument[]
    total?: number
    offset?: number
    limit?: number
    limitOptions?: number[]
    onPageClick?(offset: number): void
    onLimitChange?(limit: number): void
    simpleList: boolean
}

interface IState {
}

export default class NotesList extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        return (
            <div>
                <div style={{ margin: 40 }}>
                    {this.props.notes && this.props.notes.map((item, key) =>
                        <Paper
                            key={key}
                            zDepth={1}
                            style={{ textAlign: "left", marginBottom: 40, minHeight: 70, borderRadius: 12 }}
                        >
                            <div style={{ display: "flex", margin: 10 }}>
                                <Avatar
                                    style={{ width: 50, height: 50, minWidth: 50, minHeight: 50, marginTop: 10 }}
                                    icon={item.ObjectAudit.CreatedByAvatarS3URL === "" || item.ObjectAudit.CreatedByAvatarS3URL === null ? <AvatarPlaceholder /> : null}
                                    src={item.ObjectAudit.CreatedByAvatarS3URL !== "" && item.ObjectAudit.CreatedByAvatarS3URL !== null ? item.ObjectAudit.CreatedByAvatarS3URL : ""}
                                />
                                <div style={{ margin: 10, width: "100%" }}>
                                    {item.IsAudit ?
                                        <div style={{ display: "flex" }}>
                                            <h3 style={{ margin: "4px 0px 0px 0px" }}>{item.ObjectAudit.CreatedByName} {item.ObjectAudit.CreatedByName ? "-" : ""} {item.Title}</h3>
                                            {permissionHelper.isGlobalAdmin() && item.ObjectAudit.CreatedByGlobalAdmin &&
                                                <div title={strings.Change_Made_By_GlobalAdmin} style={{ marginLeft: "auto", order: 2 }}>
                                                    <ShieldIcon style={{ color: "#95989a", cursor: "pointer" }} />
                                                </div>
                                            }
                                        </div>
                                        :
                                        <h3 style={{ margin: "4px 0px 0px 0px" }}>{item.ObjectAudit.CreatedByName} {item.ObjectAudit.CreatedByName ? "-" : ""} {item.Title}</h3>
                                    }
                                    <p style={{ margin: "2px 0px 0px 0px", whiteSpace: "pre-wrap" }} ref={`note-${key}`}>
                                        <div dangerouslySetInnerHTML={{ __html: (item.Note.length > 150 ? item.Note.substring(0, 151) + " ... " : item.Note) }}>
                                        </div>
                                        {item.Note.length > 150 &&
                                            <span
                                                style={{ color: "blue", cursor: "pointer" }}
                                                onClick={() => {
                                                    const noteText = this.refs[`note-${key}`] as HTMLParagraphElement
                                                    noteText.innerHTML = item.Note
                                                }}
                                            >
                                                {strings.See_More}
                                            </span>
                                        }
                                    </p>
                                    {item.IsAudit ?
                                        <div style={{ display: "flex", marginBottom: -13 }}>
                                            <p style={{ fontSize: "10px" }}>{moment(item.ObjectAudit.CreatedDate).format("MM/DD/YYYY hh:mm a")}</p>
                                            {item.ObjectAudit.CreatedByName && item.ObjectAudit.CreatedByName.startsWith("SJ") &&
                                                <p style={{ marginLeft: "auto", order: 2 }}>{item.ObjectAudit.CreatedByUserId}</p>
                                            }
                                        </div>
                                        :
                                        <div>
                                            {item.NoteType && <p style={{ margin: "4px 0px 0px 0px", fontSize: "10px" }}><strong>{strings.NoteType}:</strong> {item.NoteType.Group && item.NoteType.Group + " - "}{item.NoteType.Name}</p>}
                                            {item.SubscriberEmailList && <p style={{ margin: "4px 0px 0px 0px", fontSize: "10px" }}><strong>{strings.NoteSubscribers}:</strong> {item.SubscriberEmailList}</p>}
                                            <p style={{ margin: "4px 0px 0px 0px", fontSize: "10px" }}>{moment(item.ObjectAudit.CreatedDate).format("MM/DD/YYYY hh:mma")}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </Paper>
                    )}
                </div>
                {this.props.onPageClick &&
                    <table style={{ marginLeft: "20%" }}>
                        <tbody>
                            <TableFooter
                                total={this.props.total}
                                offset={this.props.offset}
                                limit={this.props.limit}
                                limitOptions={this.props.limitOptions}
                                onPageClick={this.props.onPageClick}
                                onLimitChange={this.props.onLimitChange}
                            />
                        </tbody>
                    </table>
                }
            </div>
        )
    }
}